import { render } from "./companies-list.vue?vue&type=template&id=a7024d68"
import script from "./companies-list.vue?vue&type=script&lang=js"
export * from "./companies-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__